import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Permisos } from 'constants/Permisos';

import ProtectedComponent from 'hoc/ProtectedComponent/index';

import ListaProductos from './Lista/index';
import NuevoEditarForm from './NuevoEditarForm/index';

const TodosProductos = ({ match }) => {
    return (
        <Switch>
            <Route
                path={`${match.url}/lista`}
                render={() => (
                    <ProtectedComponent
                        permiso={Permisos.panel}
                        componente={ListaProductos}
                    />
                )}
            />
            <Route
                path={`${match.url}/nuevo`}
                render={() => (
                    <ProtectedComponent
                        permiso={Permisos.panel}
                        componente={NuevoEditarForm}
                    />
                )}
            />
            <Route
                path={`${match.url}/editar`}
                render={() => (
                    <ProtectedComponent
                        permiso={Permisos.panel}
                        componente={NuevoEditarForm}
                    />
                )}
            />
        </Switch>
    );
};

export default TodosProductos;

TodosProductos.propTypes = {
    match: PropTypes.object,
};
